import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { ActualSelected } from '../../../shared/utils';
import { STOCK_API_BASE } from '../../../consts';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes(STOCK_API_BASE)) {
      req = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.authService.authToken,
          ActivitySelected: ActualSelected.activitySelected,
          YearSelected: ActualSelected.yearSelected,
          MonthSelected: ActualSelected.monthSelected,
          Global: ActualSelected.global,
          MonthSelectedStatistic: ActualSelected.monthSelectedStatistics,
          MonthSelectedResume: ActualSelected.monthSelectedResume,
          CultureName: ActualSelected.cultureSelected
        }
      });
    }

    return next.handle(req).pipe(
      tap(
        () => {},
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              if (err.url && err.url.includes('/conciliation/api/v2/') === false) {
                const attemptedUrl = this.router.url;
                this.authService.clearLocalSession();
                if (attemptedUrl && attemptedUrl !== '/login') {
                  this.authService.redirectAfterLogin = attemptedUrl;
                }
                this.router.navigate(['/login']);
              }
            }

            /*
            if (err.status === consts.STATUS_PAYMENT_REQUIRED) {
              const url = this.router.url;
              if (!url.includes('/subscription') && !(url.includes('sig') && url.includes('item_number') && url.includes('cc'))) {
                this.router.navigate(['/subscription']);
              }
            }
            */
          }
        }
      )
    );
  }
}